import { ReactElement, useMemo } from 'react';
import type { ColumnsType } from 'antd/es/table';
import { Table as AntTable } from 'antd';
import DetailButton from './DetailButton';
import { Customer } from '@minutes-system/backend/src/api/customers/schema';

interface Props {
  data: Customer[];
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
}
const Table = ({ data, page, pageSize, total, onPageChange }: Props): ReactElement => {
  const columns: ColumnsType<Customer> = useMemo(
    () => [
      { title: 'ID', dataIndex: 'id', key: 'id', width: 120 },
      { title: '氏名', dataIndex: 'name', key: 'name', width: 240, ellipsis: true },
      {
        title: '電話番号',
        dataIndex: 'phone',
        key: 'phone',
        width: 160,
        render: (value: Customer['phone']) => value ?? '-',
      },
      {
        title: '携帯電話',
        dataIndex: 'mobilePhone',
        key: 'mobilePhone',
        width: 160,
        render: (value: Customer['mobilePhone']) => value ?? '-',
      },
      {
        title: '操作',
        key: 'action',
        width: 120,
        render: (_, record) => <DetailButton id={record.id} />,
      },
    ],
    []
  );

  return (
    <AntTable<Customer>
      rowKey='id'
      dataSource={data}
      columns={columns}
      pagination={{
        current: page,
        pageSize,
        total,
        showSizeChanger: false,
        showTotal: (total, range) => `${String(range[0])}-${String(range[1])} of ${String(total)}`,
        onChange: p => {
          onPageChange(p);
        },
      }}
    />
  );
};

export default Table;
